import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import piniaPersist from 'pinia-plugin-persistedstate';

import VueTypewriterEffect from 'vue-typewriter-effect';

import './assets/fonts/font.css';
import './index.css';

const pinia = createPinia();
pinia.use(piniaPersist);

const app = createApp(App);

app.use(router);
app.use(pinia);
app.component("vue-typewriter-effect", VueTypewriterEffect);
app.mount('#app');